import React from "react";
import packageImg from "../assets/images/packageImg.png";
import OrderCard from "../components/OrderCard";
import Header from "../components/Header";
import comingSoon from "../assets/images/coming-soon.png";

const data = [
  {
    id: 1,
    itemName: "Package - A",
    img: packageImg,
    description:
      "মুড়ি (৪০০ গ্রাম) ১ প্যাকেট চানাচুর - ৩০০ গ্রাম সরিষার তেল ...",
  },
  {
    id: 2,
    itemName: "Package - A",
    img: packageImg,
    description:
      "মুড়ি (৪০০ গ্রাম) ১ প্যাকেট চানাচুর - ৩০০ গ্রাম সরিষার তেল ...",
  },
];
const Order = () => {
  return (
    <div className="bg-accent-grey-50 h-[100vh] lg:w-[450px] w-full mx-auto">
      {/* <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div>
      <div className="space-y-2.5 mt-[-23px] mx-4">
        <div className=" p-4 flex flex-col gap-3  border border-white bg-white  h-auto rounded-lg">
          <h3 className="text-black font-poppins font-bold text-base">Order</h3>
        </div>
      </div> */}
      <Header />

      <div className="container ">
        <div className="py-5">
          <div className="flex justify-center items-center gap-4">
            <div className="flex flex-col gap-4 items-center">
              <div className="">
                <img src={comingSoon} alt="" className="w-full h-full" />
              </div>
              <h1 className="text-lg font-poppins font-bold text-accent-grey-900">
                Coming Soon
              </h1>
            </div>
          </div>
          {/* <div className="space-y-6">
            {data?.map((result) => {
              return <OrderCard result={result} />;
            })}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Order;
